import { root, id } from './onboarding';

export const onboarding = {
  ...root,
  id: {
    ...id,
  },
};
